<!--
기타운임 과금/환불 모달 컴포넌트
------------------------------------
사용: app.$refs['charge-shipping-etc-cost'].form(houseId, userId)
디자인 참조: manual-charge.vue
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical" style="width: 640px">

            <div class="uk-modal-header">
                <h4 class="uk-text-center" style="margin: 0;" v-text="isRefund ? '기타운임 환불' : '기타운임 과금'"></h4>
            </div>

            <div class="uk-modal-body" style="padding: 24px 30px;">

                <!-- 과금방식 토글 -->
                <div style="display: flex; border-radius: 10px; overflow: hidden; margin-bottom: 24px; border: 2px solid #e2e8f0;">
                    <button type="button"
                            :style="{
                                flex: '1', padding: '11px 0', border: 'none', cursor: 'pointer',
                                fontWeight: '600',
                                background: !isRefund ? '#1e87f0' : '#fff',
                                color: !isRefund ? '#fff' : '#a0aec0',
                                transition: 'all 0.15s ease'
                            }"
                            @click="inputs.charge_type = '1'">
                        과금
                    </button>
                    <button type="button"
                            :style="{
                                flex: '1', padding: '11px 0', border: 'none', borderLeft: '2px solid #e2e8f0',
                                cursor: 'pointer', fontWeight: '600',
                                background: isRefund ? '#c53030' : '#fff',
                                color: isRefund ? '#fff' : '#a0aec0',
                                transition: 'all 0.15s ease'
                            }"
                            @click="inputs.charge_type = '2'">
                        환불
                    </button>
                </div>

                <!-- 환불 안내 -->
                <div v-if="isRefund"
                     style="background: #fff5f5; border: 1px solid #feb2b2; border-radius: 8px; padding: 12px 16px; margin-bottom: 20px; color: #742a2a; line-height: 1.6;">
                    환불은 결제수단에 관계없이 <strong>예치금 입금</strong>으로 처리됩니다.
                </div>

                <!-- 하우스 정보 카드 -->
                <div v-if="house.code"
                     style="background: #f8fafc; border: 1px solid #edf2f7; border-radius: 10px; padding: 18px 20px; margin-bottom: 16px;">
                    <div style="font-weight: 600; color: #718096; margin-bottom: 14px; padding-bottom: 10px; border-bottom: 1px solid #edf2f7;">
                        하우스 정보
                    </div>
                    <div class="uk-grid uk-grid-small uk-child-width-1-2" uk-grid>
                        <div>
                            <app-column header="배송코드" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ house.code }}
                            </app-column>
                        </div>
                        <div>
                            <app-column header="수취인" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ house.name || '-' }}
                            </app-column>
                        </div>
                        <div>
                            <app-column header="송장번호" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ house.blno || '-' }}
                            </app-column>
                        </div>
                        <div>
                            <app-column header="HAWB" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ house.hawb || '-' }}
                            </app-column>
                        </div>
                    </div>
                </div>

                <!-- 회원 정보 카드 -->
                <div v-if="member.nick"
                     style="background: #f8fafc; border: 1px solid #edf2f7; border-radius: 10px; padding: 18px 20px; margin-bottom: 24px;">
                    <div style="font-weight: 600; color: #718096; margin-bottom: 14px; padding-bottom: 10px; border-bottom: 1px solid #edf2f7;">
                        회원 정보
                    </div>
                    <div class="uk-grid uk-grid-small uk-child-width-1-2" uk-grid>
                        <div>
                            <app-column header="회원사" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ member.nick }}
                            </app-column>
                        </div>
                        <div>
                            <app-column header="결제수단" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                <span v-if="isRefund" style="display: inline-flex; align-items: center; gap: 6px; background: #fff5f5; border: 1px solid #feb2b2; border-radius: 6px; padding: 2px 10px; font-size: 0.9rem;">
                                    <span style="width: 7px; height: 7px; border-radius: 50%; background: #e53e3e; flex-shrink: 0;"></span>
                                    <span>예치금 (환불)</span>
                                </span>
                                <span v-else style="display: inline-flex; align-items: center; gap: 6px; background: #f7fafc; border: 1px solid #e2e8f0; border-radius: 6px; padding: 2px 10px; font-size: 0.9rem;">
                                    <span style="width: 7px; height: 7px; border-radius: 50%; background: #48bb78; flex-shrink: 0;"></span>
                                    <span v-text="member.pm_label"></span>
                                </span>
                            </app-column>
                        </div>
                    </div>
                </div>

                <!-- 과금 정보 섹션 -->
                <div style="font-weight: 600; color: #4a5568; margin-bottom: 16px; padding-bottom: 10px; border-bottom: 2px solid #edf2f7;">
                    <span v-text="isRefund ? '환불 정보' : '과금 정보'"></span>
                </div>

                <!-- 금액 -->
                <div class="uk-margin">
                    <label class="uk-form-label" v-text="isRefund ? '기타운임 환불 금액 (원)' : '기타운임 과금 금액 (원)'"></label>
                    <div class="uk-form-controls">
                        <input class="uk-input" type="text"
                               v-model="inputs.cost"
                               @input="onCostInput"
                               placeholder="이 금액이 과금처리 됩니다">
                    </div>
                </div>

                <!-- 비고 -->
                <div class="uk-margin">
                    <label class="uk-form-label">비고</label>
                    <div class="uk-form-controls">
                        <textarea class="uk-textarea" rows="3"
                                  v-model="inputs.memo"
                                  :placeholder="isRefund ? '기타운임 환불 사유를 입력하세요' : '기타운임 과금 사유를 입력하세요'"></textarea>
                    </div>
                </div>

                <!-- 결제/환불 요약 -->
                <div v-if="cost > 0"
                     style="border-radius: 10px; padding: 18px 20px; margin-top: 20px; border: 1px solid #e2e8f0;"
                     :style="{ background: isRefund ? '#fff5f5' : '#f7fafc' }">
                    <div style="font-weight: 600; margin-bottom: 14px; padding-bottom: 10px; border-bottom: 1px solid #e2e8f0;">
                        <span v-text="isRefund ? '환불 요약' : '결제 요약'"></span>
                    </div>
                    <div class="uk-flex uk-flex-between" style="padding: 6px 0; color: #718096;">
                        <span v-text="isRefund ? '환불금액' : '기본과금액'"></span>
                        <span style="color: #2d3748; font-weight: 500;">{{ numberFormat(cost) }} 원</span>
                    </div>
                    <div v-if="isCard && !isRefund" class="uk-flex uk-flex-between" style="padding: 6px 0; color: #718096;">
                        <span>카드수수료 ({{ feeRatePercent }}%)</span>
                        <span style="color: #2d3748; font-weight: 500;">{{ numberFormat(feeAmount) }} 원</span>
                    </div>
                    <div v-if="isCard && !isRefund" class="uk-flex uk-flex-between" style="padding: 6px 0; color: #718096;">
                        <span>카드수수료 부가세</span>
                        <span style="color: #2d3748; font-weight: 500;">{{ numberFormat(feeVatAmount) }} 원</span>
                    </div>
                    <div class="uk-flex uk-flex-between"
                         :style="{
                             borderTop: '2px solid ' + (isRefund ? '#feb2b2' : '#bee3f8'),
                             marginTop: '10px', paddingTop: '12px',
                             fontWeight: '700', fontSize: '1.1rem'
                         }">
                        <span v-text="isRefund ? '최종 환불금액' : '최종 결제금액'"></span>
                        <span :style="{ color: isRefund ? '#c53030' : '#1e87f0' }">{{ numberFormat(totalAmount) }} 원</span>
                    </div>
                </div>

                <!-- 영세율 안내 (과금 + 카드일 때만) -->
                <div v-if="isCard && !isRefund && cost > 0"
                     style="background: #fffbeb; border: 1px solid #f6e05e; border-radius: 8px; padding: 12px 16px; margin-top: 12px; color: #744210; line-height: 1.6;">
                    <span style="font-weight: 600;">PG 과세유형 안내</span> &mdash;
                    기타운임의 카드수수료에는 부가세(10%)가 별도 부과됩니다.
                </div>

                <!-- 에러 메시지 -->
                <div v-if="errorMsg" class="uk-alert uk-alert-danger" style="margin-top: 16px;">
                    {{ errorMsg }}
                </div>
            </div>

            <div class="uk-modal-footer uk-text-right">
                <button type="button"
                        class="uk-button uk-button-default uk-modal-close">
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button type="button"
                        class="uk-button"
                        :style="{
                            background: isRefund ? '#c53030' : '#1e87f0',
                            color: '#fff',
                            border: '1px solid ' + (isRefund ? '#c53030' : '#1e87f0')
                        }"
                        :disabled="submitting"
                        @click="submit()">
                    <span uk-icon="icon: check"></span>
                    {{ isRefund ? '환불 실행' : '과금 실행' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            csrfToken: String,
            cardFeeRate: { type: Number, default: 0.035 },
        },
        data: function () {
            return {
                member: {},
                house: {},
                houseId: null,
                userId: null,
                inputs: {
                    charge_type: '1',
                    cost: '',
                    memo: '',
                },
                cost: 0,
                errorMsg: '',
                submitting: false,
            };
        },
        computed: {
            isCard: function () {
                return this.member.is_card || false;
            },
            isRefund: function () {
                return this.inputs.charge_type === '2';
            },
            feeRatePercent: function () {
                return parseFloat((this.cardFeeRate * 100).toFixed(2));
            },
            feeAmount: function () {
                if (this.isRefund) return 0;
                return this.isCard ? Math.floor(this.cost * this.cardFeeRate) : 0;
            },
            feeVatAmount: function () {
                return this.isCard ? Math.floor(this.feeAmount * 0.1) : 0;
            },
            totalAmount: function () {
                return this.cost + this.feeAmount + this.feeVatAmount;
            },
        },
        methods: {
            /**
             * 폼 — 외부에서 호출
             * @param {Number} house_id 하우스 ID
             * @param {Number} user_id 회원 ID
             */
            form: function (house_id, user_id, house_info) {
                this.houseId = house_id;
                this.userId = user_id;
                this.house = house_info || {};
                this.inputs = { charge_type: '1', cost: '', memo: '' };
                this.cost = 0;
                this.member = {};
                this.errorMsg = '';
                this.submitting = false;

                // 회원 결제수단 정보 로드
                var self = this;
                var loadUser = new Promise(function (resolve) {
                    $.app.ajax.module.background({
                        type: 'get',
                        url: '/company-users/' + user_id,
                        contentType: 'application/json',
                        data: {},
                        success: function (response) { resolve(response); },
                    });
                });

                var loadMemberData = new Promise(function (resolve) {
                    $.app.ajax.module.background({
                        type: 'get',
                        url: '/admin/billings/manual-charge/member-data/' + user_id,
                        contentType: 'application/json',
                        data: {},
                        success: function (response) { resolve(response); },
                    });
                });

                Promise.all([loadUser, loadMemberData]).then(function (results) {
                    var userResponse = results[0];
                    var memberData = results[1];

                    self.member = {
                        nick: userResponse.user.nick,
                        pm_label: memberData.pm_label,
                        is_card: memberData.is_card,
                    };

                    UIkit.modal(self.$el).show();
                });
            },

            /**
             * 금액 입력 핸들러
             */
            onCostInput: function () {
                this.cost = parseInt(this.inputs.cost) || 0;
            },

            /**
             * submit
             */
            submit: function () {
                if (this.cost < 1) {
                    this.errorMsg = (this.isRefund ? '환불' : '과금') + ' 금액은 최소 1원 이상이어야 합니다.';
                    return;
                }

                this.errorMsg = '';
                this.submitting = true;

                var self = this;
                var load = new Promise(function (resolve, reject) {
                    $.app.ajax.module.default({
                        type: 'post',
                        url: '/houses/' + self.houseId + '/shipping-etc-costs',
                        data: {
                            '_token': self.csrfToken,
                            'charge_type': self.inputs.charge_type,
                            'cost': self.inputs.cost,
                            'memo': self.inputs.memo,
                        },
                        success: function (response) { resolve(response); },
                        error: function (jqXHR) { reject(jqXHR); },
                    });
                });

                load.then(function (response) {
                    UIkit.modal(self.$el).hide();
                    UIkit.modal.alert(response.msg).then(function () {
                        $.app.refresh();
                    });
                }).catch(function (jqXHR) {
                    self.submitting = false;

                    if (jqXHR.status === 422 && jqXHR.responseJSON) {
                        var errors = jqXHR.responseJSON;
                        var msgs = [];
                        for (var field in errors) {
                            if (Array.isArray(errors[field])) {
                                msgs.push(errors[field][0]);
                            }
                        }
                        self.errorMsg = msgs.join('\n') || '입력값을 확인하세요.';
                    } else if (jqXHR.responseJSON && jqXHR.responseJSON.msg) {
                        self.errorMsg = jqXHR.responseJSON.msg;
                    } else {
                        self.errorMsg = '요청 처리 중 오류가 발생했습니다.';
                    }
                });
            },

            /**
             * 숫자 포맷
             */
            numberFormat: function (num) {
                return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
        },
    };
</script>
